<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="modalTitle" aria-modal="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Załączniki do zapytania ofertowego (Oferta)</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">

          <div v-if="groupedQuoteRequests.length">

            <div v-for="req in groupedQuoteRequests" :key="req.quote_requests" class="mb-4">

              <h6 class="fw-bold d-flex justify-content-between">
                <span>Oferta: {{ req.quote_requests }}</span>
                <span class="text-muted small">
                  {{ req.files.length }} plików
                </span>
              </h6>

              <ul v-if="req.files.length" class="list-group mb-2">
                <li v-for="file in req.files" :key="file.id" class="list-group-item">
                  <a :href="route('quoteRequests.files.show', { file: file.id })" target="_blank">
                    {{ file.original_name }}
                  </a>
                </li>
              </ul>

              <div v-else class="text-muted ps-3">
                Brak plików dla tej oferty
              </div>

            </div>

          </div>

          <div v-else class="alert alert-warning">
            Brak zaznaczonych rekordów.
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            Zamknij
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    quoteRequests: {
      type: Array,
      default: () => []
    }
  },

  emits: ['close'],

  computed: {
    groupedQuoteRequests() {
      const map = new Map();

      this.quoteRequests.forEach(req => {

        const key = req.quote_requests;

        if (!map.has(key)) {
          map.set(key, {
            quote_requests: req.quote_requests,
            files: []
          });
        }

        const entry = map.get(key);

        (req.files || []).forEach(f => {
          if (!entry.files.find(x => x.id === f.id)) {
            entry.files.push(f);
          }
        });

      });

      return Array.from(map.values());
    }
  }
}
</script>

<style scoped>
.modal.show {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>